import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useToasts } from 'react-toast-notifications'
import { Spinner } from 'reactstrap'
import { BiPlus } from 'react-icons/bi'
import { MdKeyboardArrowRight } from 'react-icons/md'

import useBodyClass from '_hooks/useBodyClass'
import { useModal } from '_hooks/useModal'
import { getUserInfo } from '_utils/localData'
import { getListPackingList, getMyEvents } from '_redux/modules/event'
import { ReactComponent as EventCountIcon } from '_icons/event-count.svg'
import { ReactComponent as OrderCountIcon } from '_icons/order-count.svg'
import { ReactComponent as PackageIcon } from '_icons/package-icon.svg'
import AddPackingListModal from '../components/AddPackingListModal'

import './style.scss'

export default function ManagePackingList() {
  useBodyClass('hosted-event-change-bg')

  const dispatch = useDispatch()
  const history = useHistory()
  const { addToast } = useToasts()

  const userInfo = getUserInfo()
  const { listPackingList, myEvents } = useSelector((state) => state.event)

  const [isLoading, setIsLoading] = useState(true)
  const {
    isOpen: isPackingListOpen,
    toggleModal: togglePackingListModal,
  } = useModal()

  useEffect(() => {
    const fetchLists = async () => {
      try {
        await dispatch(getListPackingList)
      } finally {
        setIsLoading(false)
      }
    }
    fetchLists()
  }, [dispatch])

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        await dispatch(getMyEvents)
      } catch (error) {
        addToast(error?.message, { appearance: 'error', autoDismiss: true })
      }
    }
    fetchEvents()
  }, [dispatch])

  const handleTogglePackingListModal = () => {
    if (!userInfo?.isUsingFeature) {
      addToast('This feature is currently available to a limited set of users for testing', {
        appearance: 'info',
        autoDismiss: true,
      })
      return
    }
    togglePackingListModal()
  }

  return (
    <div className='manage-packing-list'>
      <div className='page-header'>
        <div>
          <div className='page-title'>Packing List</div>
          <div className='page-subtitle'>Create and manage packing lists per buyer</div>
        </div>
        <button className='btn-primary' onClick={handleTogglePackingListModal}>
          <BiPlus size={16} />
          New Packing List
        </button>
      </div>

      {isLoading ? (
        <div className='loading-packages'>
          <Spinner size='sm' color='primary' />
        </div>
      ) : listPackingList?.length ? (
        <div className='package-grid'>
          {listPackingList.map((item) => {
            const displayName = item.name?.includes('/')
              ? 'example name'
              : item.name || 'Unnamed list'
            const eventsCount = item.eventIds?.length || 0
            const ordersCount = item.totalOrderCount || 0
            return (
              <div
                key={item.id}
                className='package-card'
                onClick={() => history.push(`/event/packing-list?id=${item.id}`)}
              >
                <div className='package-icon'>
                  <PackageIcon />
                </div>
                <div className='package-info'>
                  <div className='package-name'>{displayName}</div>
                  <div className='package-meta'>
                    <span>
                      <EventCountIcon width='11' height='11' />
                      {eventsCount} {eventsCount === 1 ? 'event' : 'events'}
                    </span>
                    <span>
                      <OrderCountIcon width='11' height='11' />
                      {ordersCount} {ordersCount === 1 ? 'total order' : 'total orders'}
                    </span>
                  </div>
                </div>
                <MdKeyboardArrowRight className='package-arrow' size={18} />
              </div>
            )
          })}
        </div>
      ) : (
        <div className='empty-packages'>
          <div className='empty-icon'>
            <PackageIcon width='28' height='28' />
          </div>
          <h4>No Packing Lists Yet</h4>
          <p>Create a packing list to consolidate orders and generate buyer packages.</p>
          <button
            className='btn-primary'
            style={{ margin: '0 auto' }}
            onClick={handleTogglePackingListModal}
          >
            <BiPlus size={16} />
            New Packing List
          </button>
        </div>
      )}

      {isPackingListOpen && (
        <AddPackingListModal
          modal={isPackingListOpen}
          toggle={togglePackingListModal}
          listEvent={myEvents}
        />
      )}
    </div>
  )
}
